// Utilitário simples para zoom da tela persistido por usuário logado.
// Chave: brave_user_zoom_{codigo_origem}_{login_cliente}
// Valor: percentual (string), ex: "100"

const DEFAULT_ZOOM = 100;

const getCliente = () => {
  try {
    return JSON.parse(sessionStorage.getItem("brave_cliente_data") || "{}");
  } catch {
    return {};
  }
};

export const getUserZoomKey = () => {
  const c = getCliente();
  const cod = c.codigo_origem ?? c.codigo ?? "default";
  const login = c.login_cliente || "default";
  return `brave_user_zoom_${cod}_${login}`;
};

export const getUserZoom = () => {
  const v = parseInt(localStorage.getItem(getUserZoomKey()) || "", 10);
  return Number.isFinite(v) && v > 0 ? v : DEFAULT_ZOOM;
};

export const applyZoom = (pct) => {
  const n = parseInt(pct, 10);
  if (!Number.isFinite(n) || n <= 0) return;
  // `zoom` é suportado em Chromium/WebKit e agora também no Firefox 126+
  document.documentElement.style.zoom = `${n}%`;
};

export const setUserZoom = (pct) => {
  const n = parseInt(pct, 10);
  if (!Number.isFinite(n) || n <= 0) return;
  localStorage.setItem(getUserZoomKey(), String(n));
  applyZoom(n);
};

export const ZOOM_OPTIONS = [
  { value: "70", label: "70%" },
  { value: "80", label: "80%" },
  { value: "90", label: "90%" },
  { value: "100", label: "100% (padrão)" },
  { value: "110", label: "110%" },
  { value: "125", label: "125%" },
  { value: "150", label: "150%" },
];
